module.exports = __webpack_public_path__ + "img/bank.78896bbb.svg";